import { parse } from 'messageformat-parser';
import * as makePlural_ from 'make-plural';
import { createContext, createElement, Component, Fragment } from 'react';

function parse$1(source) {
    var tokens = parse(source, { strict: true });
    return tokens;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends$1(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var makePlural = makePlural_;
function getValue(key, values) {
    if (values == null) {
        throw new Error("expected \"" + key + "\" to exist but values is not provided");
    }
    if (!values.hasOwnProperty(key)) {
        throw new Error("expected \"" + key + "\" to exist");
    }
    var value = values[key];
    return value;
}
function getNumber(key, values) {
    var value = getValue(key, values);
    if (typeof value !== "number") {
        throw new Error("expected \"" + key + "\" to be a number");
    }
    return value;
}
function getString(key, values) {
    var value = getValue(key, values);
    if (typeof value !== "string") {
        throw new Error("expected \"" + key + "\" to be a string");
    }
    return value;
}
function resolveSelectCase(select, values) {
    var arg = select.arg, cases = select.cases;
    var value = getString(arg, values);
    var targetIndex;
    var otherIndex;
    for (var i = 0; i < cases.length; ++i) {
        var c = cases[i];
        if (c.key === "other") {
            otherIndex = i;
        }
        if (c.key === value) {
            targetIndex = i;
        }
    }
    if (otherIndex === undefined) {
        throw new Error("expected other case");
    }
    if (targetIndex !== undefined) {
        return cases[targetIndex];
    }
    return cases[otherIndex];
}
function resolvePluralFunc(locale) {
    var func = makePlural[locale];
    if (func == null) {
        throw new Error("unsupported locale: " + locale);
    }
    return func;
}
function resolvePluralCase(pluralOrSelectOrdinal, locale, values) {
    var type = pluralOrSelectOrdinal.type, arg = pluralOrSelectOrdinal.arg, offsetString = pluralOrSelectOrdinal.offset, cases = pluralOrSelectOrdinal.cases;
    var offset = parseInt(offsetString, 10);
    if (isNaN(offset)) {
        throw new Error("invalid offset");
    }
    var ordinal = type === "selectordinal";
    var pluralFunc = resolvePluralFunc(locale);
    var rawValue = getNumber(arg, values);
    var offsetValue = rawValue - offset;
    var pluralRule = pluralFunc(offsetValue, ordinal);
    var valueAsString = String(rawValue);
    var targetIndex;
    var otherIndex;
    for (var i = 0; i < cases.length; ++i) {
        var c = cases[i];
        if (c.key === "other") {
            otherIndex = i;
        }
        if (targetIndex === undefined) {
            if (c.key === valueAsString) {
                targetIndex = i;
            }
            if (c.key === pluralRule) {
                targetIndex = i;
            }
        }
    }
    if (otherIndex === undefined) {
        throw new Error("expected other case");
    }
    if (targetIndex !== undefined) {
        return {
            currentValue: offsetValue,
            pluralCase: cases[targetIndex],
        };
    }
    return {
        currentValue: offsetValue,
        pluralCase: cases[otherIndex],
    };
}
function evaluateToInternalValue(tokens, locale, values, currentValue) {
    var e_1, _a;
    var output = [];
    try {
        for (var tokens_1 = __values(tokens), tokens_1_1 = tokens_1.next(); !tokens_1_1.done; tokens_1_1 = tokens_1.next()) {
            var token = tokens_1_1.value;
            if (typeof token === "string") {
                output.push(token);
            }
            else {
                switch (token.type) {
                    case "argument": {
                        var value = getValue(token.arg, values);
                        output.push(value);
                        break;
                    }
                    case "plural": {
                        var result = resolvePluralCase(token, locale, values);
                        var nestedTokens = evaluateToInternalValue(result.pluralCase.tokens, locale, values, result.currentValue);
                        output.push(nestedTokens);
                        break;
                    }
                    case "selectordinal": {
                        var result = resolvePluralCase(token, locale, values);
                        var nestedTokens = evaluateToInternalValue(result.pluralCase.tokens, locale, values, result.currentValue);
                        output.push(nestedTokens);
                        break;
                    }
                    case "select": {
                        var selectCase = resolveSelectCase(token, values);
                        var nestedTokens = evaluateToInternalValue(selectCase.tokens, locale, values, currentValue);
                        output.push(nestedTokens);
                        break;
                    }
                    case "octothorpe": {
                        if (currentValue == null) {
                            throw new Error("unexpected #");
                        }
                        output.push(currentValue);
                        break;
                    }
                    default: {
                        throw new Error("unexpected type: " + token.type);
                        break;
                    }
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tokens_1_1 && !tokens_1_1.done && (_a = tokens_1.return)) _a.call(tokens_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return output;
}
function toValues(intervalValues) {
    var e_2, _a;
    var output = [];
    try {
        for (var intervalValues_1 = __values(intervalValues), intervalValues_1_1 = intervalValues_1.next(); !intervalValues_1_1.done; intervalValues_1_1 = intervalValues_1.next()) {
            var v = intervalValues_1_1.value;
            if (Array.isArray(v)) {
                output.push.apply(output, __spread(toValues(v)));
            }
            else {
                output.push(v);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (intervalValues_1_1 && !intervalValues_1_1.done && (_a = intervalValues_1.return)) _a.call(intervalValues_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return output;
}
function toOutputValues(values) {
    var e_3, _a;
    var output = [];
    try {
        for (var values_1 = __values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
            var v = values_1_1.value;
            if (typeof v === "number") {
                output.push(String(v));
            }
            else {
                output.push(v);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return output;
}
function evaluate(tokens, locale, values) {
    var internalValues = evaluateToInternalValue(tokens, locale, values, undefined);
    return toOutputValues(toValues(internalValues));
}

var defaultValue = {
    locale: "en",
    compile: function () { return []; },
    renderToString: function () { return ""; },
};
var _a = createContext(defaultValue), Provider_ = _a.Provider, Consumer = _a.Consumer;
var Provider = /** @class */ (function (_super) {
    __extends$1(Provider, _super);
    function Provider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tokensByID = {};
        _this.state = {
            version: 0,
        };
        _this.compile = function (id) {
            var _a;
            var cachedTokens = _this.tokensByID[id];
            if (cachedTokens != null) {
                return cachedTokens;
            }
            var source = _this.props.messageByID[id];
            if (source == null) {
                throw new Error("expected \"" + id + "\" to exist");
            }
            var tokens = parse$1(source);
            _this.tokensByID = __assign$1({}, _this.tokensByID, (_a = {}, _a[id] = tokens, _a));
            return tokens;
        };
        _this.renderToString = function (id, values) {
            var e_1, _a;
            var locale = _this.props.locale;
            var tokens = _this.compile(id);
            var result = evaluate(tokens, locale, values);
            var output = [];
            try {
                for (var result_1 = __values(result), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()) {
                    var a = result_1_1.value;
                    if (typeof a !== "string") {
                        throw new Error("unexpected non-string value \"" + id + "\"");
                    }
                    output.push(a);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (result_1_1 && !result_1_1.done && (_a = result_1.return)) _a.call(result_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return output.join("");
        };
        return _this;
    }
    Provider.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.locale !== prevProps.locale) {
            this.tokensByID = {};
            this.setState(function (prevState) {
                return {
                    version: prevState.version + 1,
                };
            });
        }
    };
    Provider.prototype.render = function () {
        var _a = this.props, locale = _a.locale, children = _a.children;
        return (createElement(Provider_, { value: {
                locale: locale,
                compile: this.compile,
                renderToString: this.renderToString,
            } }, children));
    };
    return Provider;
}(Component));
function Message(props) {
    var id = props.id, values = props.values, locale = props.locale, compile = props.compile;
    var tokens = compile(id);
    var result = evaluate(tokens, locale, values);
    var children = [];
    for (var i = 0; i < result.length; ++i) {
        var element = result[i];
        children.push(createElement(Fragment, { key: i }, element));
    }
    return createElement(Fragment, null, children);
}
var FormattedMessage = /** @class */ (function (_super) {
    __extends$1(FormattedMessage, _super);
    function FormattedMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderMessage = function (contextValue) {
            var _a = _this.props, id = _a.id, values = _a.values;
            var locale = contextValue.locale, compile = contextValue.compile;
            return (createElement(Message, { id: id, values: values, locale: locale, compile: compile }));
        };
        return _this;
    }
    FormattedMessage.prototype.render = function () {
        return createElement(Consumer, null, this.renderMessage);
    };
    return FormattedMessage;
}(Component));
var FormattedDate_ = /** @class */ (function (_super) {
    __extends$1(FormattedDate_, _super);
    function FormattedDate_() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormattedDate_.prototype.render = function () {
        var _a = this.props, value = _a.value, locale = _a.locale, options = __rest(_a, ["value", "locale"]);
        var dateFormat = new Intl.DateTimeFormat(locale, options);
        var output = dateFormat.format(value);
        return output;
    };
    return FormattedDate_;
}(Component));
var FormattedDate = /** @class */ (function (_super) {
    __extends$1(FormattedDate, _super);
    function FormattedDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDate = function (contextValue) {
            var locale = contextValue.locale;
            return createElement(FormattedDate_, __assign$1({}, _this.props, { locale: locale }));
        };
        return _this;
    }
    FormattedDate.prototype.render = function () {
        return createElement(Consumer, null, this.renderDate);
    };
    return FormattedDate;
}(Component));

export { parse$1 as parse, evaluate, Provider, Consumer, FormattedMessage, FormattedDate };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@oursky/react-messageformat/dist/index.esm.js
// module id = 111
// module chunks = 0